import {
    ADMIN_ROUTE,
    CART_ROUTE,
    FORGOT_PASSWORD_ROUTE,
    LOGIN_ROUTE, ORDER_PLACING_ROUTE,
    ORDERS_ROUTE,
    PRIVACY_ROUTE,
    PROFILE_ROUTE,
    REGISTER_ROUTE
} from "./util/Constants";
import Privacy from "./components/legal/Privacy";
import Admin from "./components/admin/Admin";
import Profile from "./components/profile/Profile";
import Orders from "./components/orders/Orders";
import Login from "./components/login/Login";
import Cart from "./components/cart/Cart";
import Order from "./components/orders/Order";
import OrderCreation from "./components/orders/OrderCreation";

export const authRoutes = [
    {
        path: PROFILE_ROUTE,
        Component: Profile
    },
    {
        path: ORDERS_ROUTE,
        Component: Orders
    }
]

export const adminRoutes = [
    {
        path: ADMIN_ROUTE,
        Component: Admin
    }
]

export const unauthRoutes = [
    {
        path: ORDERS_ROUTE + '/:id',
        Component: Order
    },
    {
        path: LOGIN_ROUTE,
        Component: Login
    },
    {
        path: FORGOT_PASSWORD_ROUTE,
        Component: Login
    },
    {
        path: REGISTER_ROUTE,
        Component: Login
    },
    {
        path: CART_ROUTE,
        Component: Cart
    },
    {
        path: PRIVACY_ROUTE,
        Component: Privacy
    },
    {
        path: ORDER_PLACING_ROUTE,
        Component: OrderCreation
    }
]